import fieldChange from './el-field-change';
export var vModelString = {
  mixins: [fieldChange],
  props: {
    value: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {
      currentValue: ''
    };
  },
  watch: {
    value: {
      handler: function handler() {
        this.vModelMixinResetCurrentValue();
      },
      immediate: true
    }
  },
  methods: {
    vModelMixinResetCurrentValue: function vModelMixinResetCurrentValue() {
      this.currentValue = this.value;
    },
    vModelMixinEmit: function vModelMixinEmit() {
      this.$emit('input', this.currentValue);
      this.$emit('change', this.currentValue);
      this.fieldChange();
    }
  }
};